import { Box } from '@material-ui/core';
import React from 'react';
import CustomDataTable from '../../components/Table/CustomDataTable';
import LogsFilter from './LogsFilter';

function LogTable({ tableConfig, data, loading }) {
  return (
    <Box>
      <CustomDataTable
        tableData={data}
        tableConfig={tableConfig}
        loading={loading}
        filterField="activityLogDesc"
      />
    </Box>
  );
}

export default LogTable;
